import { Badge, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import React from 'react';
import { arrayOf, func, shape } from 'prop-types';
import I18n from 'i18n-js';
import CommentItem from './CommentItem';

const { Text } = Typography;

const CommentList = ({ comments = [], onUpdate = null }) => (
  <div className="ticket-comments-list">
    <div className="ticket-comments-list__header">
      <CommentOutlined className="ticket-comments-list__header-icon" />
      <Text strong>
        {I18n.t('ticket_comments.title')}
      </Text>
      <Badge count={comments.length} className="ticket-comments-list__badge" />
    </div>

    <div className="ticket-comments-list__items">
      {comments.map((item) => (
        <CommentItem key={item.id} {...item} onUpdate={onUpdate} />
      ))}
    </div>
  </div>
);

CommentList.propTypes = {
  comments: arrayOf(shape({})),
  onUpdate: func,
};

export default CommentList;
